import userManagementService from '@services/user_management.service.js';

import { INIT_PERMISSIONS, SET_PERMISSIONS } from '@store/modules/permission/constants';

const state = {
    permissions: [],
};

const mutations = {
    [SET_PERMISSIONS](state, data) {
        state.permissions = data;
    },
};

const actions = {
    [INIT_PERMISSIONS]({ commit }) {
        return userManagementService.getPermissions().then((companies) => {
            commit(SET_PERMISSIONS, companies);
            return companies;
        });
    },
};

const getters = {
    canWrite(state, getters) {
        return !!getters.isOwner;
    },
    isOwner(state, getters, rootState, rootGetters) {
        return !!(
            !(rootGetters.selectedPlace?.is_demo && !rootGetters.selectedCompany?.company?.is_demo_company) &&
            rootGetters.selectedCompany?.company?.role === 'owner'
        );
    },
    canWritePlace(state, getters) {
        return getters.isOwnerPlace;
    },
    isOwnerPlace(state, getters, rootState, rootGetters) {
        return getters.isOwner || rootGetters.selectedPlace?.role === 'owner';
    },
    canEditMeasurementsForPlace(state, getters, rootState, rootGetters) {
        if (!rootGetters.selectedPlace) {
            return false;
        }
        const roles = rootGetters.selectedPlace?.role?.split(',');
        return roles && roles.includes('temp-measurements');
    },
    canEditMeasurements(state, getters, rootState, rootGetters) {
        if (!rootGetters.selectedCompany) {
            return false;
        }
        const roles = rootGetters.selectedCompany?.company?.role?.split(',');

        return (
            getters.canWritePlace ||
            getters.canEditMeasurementsForPlace ||
            (roles && roles.includes('temp-measurements'))
        );
    },
    canEditPersonnel(state, getters) {
        return getters.canWritePlace;
    },
    permissions(state) {
        return state.permissions;
    },
};
export default {
    state,
    mutations,
    actions,
    getters,
};
